export default {
  statusPends: [],
  pagination: {},
  statusPend: {}
}
